import styled from "@emotion/styled";

export const FooterWrapper = styled.footer`
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xl};
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.border};
  display: flex;
  flex-direction: column;
  align-items: center; /* <-- ДОДАЛИ ЦЕНТРУВАННЯ ДЛЯ МОБІЛКИ */
  gap: ${({ theme }) => theme.spacing.md};
  background-color: transparent;

  @media (min-width: 48rem) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 48rem) {
    /* Додав трохи більше "повітря" (padding-top/bottom) для мобілки, щоб не прилипало до контенту */
    padding: ${({ theme }) => theme.spacing.lg}
      ${({ theme }) => theme.spacing.md};
    text-align: center; /* <-- Щоб довгий текст копірайту центрувався */
  }
`;

export const FooterText = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0;
`;

export const FooterNotice = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  opacity: 0.85;
  margin-top: 0.25rem;
`;

export const FooterLinks = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  flex-wrap: wrap;
  justify-content: center; /* <-- ЦЕНТРУЄМО ПОСИЛАННЯ */

  a {
    font-size: ${({ theme }) => theme.typography.sizes.sm};
    color: ${({ theme }) => theme.colors.textMuted};
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
